import './Interests.css' 

const Interests = () =>{

    return (
  <div id ="scroll" >    
  <div className="ButtonScroll "  >
    <button className="but" type="button">  ⚽World Cup</button>
    <button className="but1" type="button"> 📰News</button>
    <button className="but2" type="button"> 🇺🇦Ukraine</button>
    <button className="but3" type="button"> 🎭Anime</button>
    <button className="but4" type="button"> 🐱Cats</button>
    <button className="but5" type="button"> 💰Crypto</button>
    <button className="but6" type="button"> 🕹Games</button>
    <button className="but7" type="button"> 📽Movies</button>
    <button className="but8" type="button"> ☕Lifestyle</button>
    <button className="but9" type="button"> 💃Pretty Girls</button>
   </div>
   </div>
    )
}
export default Interests;